import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/problem-lists/card-footer/card-footer-container.tsx");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/components/problem-lists/problem-list-item/problem-list-item.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/problem/figure-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/problem/figure-statement-below/figure-statement-container-below.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/problem/figure-statement/figure-statement-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/problem/note-content.tsx");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/components/problem/statement.module.css");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/components/store-provider.tsx");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/components/thematics/thematics.module.css");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/components/thematics/thematics-nav-item.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/utils/copy-id-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/utils/restore-scroll-position.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/node/newtonik/master/app/ui/components/utils/store-previous-url.tsx");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/app/ui/markdown/markdown-extended.module.css");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-collapsible/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-context-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-form/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-hover-card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-label/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-menubar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-portal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-radio-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-scroll-area/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-toggle-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-toggle/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-toolbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/avatar.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/callout.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/checkbox-cards.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/checkbox-group.js");
;
import(/* webpackMode: "eager", webpackExports: ["Checkbox"] */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/checkbox.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/context-menu.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/dropdown-menu.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/radio-group.js");
;
import(/* webpackMode: "eager", webpackExports: ["Radio"] */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/radio.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/segmented-control.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/select.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/text-field.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemePanel"] */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/theme-panel.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/@radix-ui/themes/dist/esm/components/theme.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/next/font/google/target.css?{\"path\":\"app/ui/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/var/node/newtonik/master/node_modules/next/font/google/target.css?{\"path\":\"app/ui/fonts.ts\",\"import\":\"Noto_Serif\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\",\"cyrillic\"]}],\"variableName\":\"notoSerif\"}");
